import { BabaBundle } from 'templates/Bundles/Baba';
import { BagelcodeBundle } from 'templates/Bundles/Bagelcode';
import { Bagelcode2Bundle } from 'templates/Bundles/Bagelcode_2';
import { BingoPopBundle } from 'templates/Bundles/BingoPop';
import { CandivoreBundle } from 'templates/Bundles/Candivore';
import { Candivore2Bundle } from 'templates/Bundles/Candivore_2';
import { CashmanCasinoBundle } from 'templates/Bundles/CashmanCasino';
import { ClassicBundle } from 'templates/Bundles/Classic/Bundle';
import { CommunixBundle } from 'templates/Bundles/Communix';
import { GhostBundle } from 'templates/Bundles/GhostStudio';
import { HeartOfVegasBundle } from 'templates/Bundles/HeartOfVegas';
import { MainSubBundle } from 'templates/Bundles/HugeCasino/Bundle';
import { LightningLinkBundle } from 'templates/Bundles/LightningLinkCasino';
import { LocoBingoBundle } from 'templates/Bundles/LocoBingo';
import { Me2onBundle } from 'templates/Bundles/Me2on';
import { MightyFuBundle } from 'templates/Bundles/MightyFuCasino';
import { PipaBundle } from 'templates/Bundles/Pipa';
import { PlaySimpleBundle } from 'templates/Bundles/PlaySimple';
import { JackpotSlotsBundle } from 'templates/Bundles/ProductMadness';
import { WhispersBundle } from 'templates/Bundles/Whispers';
import { BabaSpecialOffer } from 'templates/SpecialOffer/Baba';
import { BagelCodeSpecialOffer } from 'templates/SpecialOffer/BagelCode';
import { BingoPopSpecialOffer } from 'templates/SpecialOffer/BingoPop';
import { GhostSpecialOffer } from 'templates/SpecialOffer/GhostStudio';
import { HugeSpecialOffer } from 'templates/SpecialOffer/HugeCasino';
import { LocoBingoSpecialOffer } from 'templates/SpecialOffer/LocoBingo';
import { MatchMastersSpecialOffer } from 'templates/SpecialOffer/MatchMasters';
import { Me2onSpecialOffer } from 'templates/SpecialOffer/Me2on';
import { PipaSpecialOffer } from 'templates/SpecialOffer/Pipa';
import { PlaySimpleSpecialOffer } from 'templates/SpecialOffer/PlaySimple';
import { PokerFaceSpecialOffer } from 'templates/SpecialOffer/PokerFace';
import { ProductMadnessSpecialOffer } from 'templates/SpecialOffer/ProductMadness';
import { SpecialOfferProps } from 'templates/SpecialOffer/types';
import {
  EBundlesInternalViewModel,
  EConfigs,
  ESpecialOfferInternalViewModel,
} from 'utils/enums';
import { BundleProps } from 'utils/types';
import { LightningLinkPlayerLevel } from 'templates/PlayerLevel/LightningLink';
import { EvergreenDynamicBundle } from 'templates/Bundles/EvergreenDynamic';
import { Communix2Bundle } from 'templates/Bundles/Communix_2';
import { HeartOfVegasMapPlayerLevel } from 'templates/PlayerLevel/HeartOfVegas/player-level-map';
import { CashmanCasinoPlayerLevel } from 'templates/PlayerLevel/CashmanCasino';
import { DynamicHeartOfVegasBundle } from 'templates/Bundles/PM_Dynamic/HOV';
import { DynamicLightningLinkBundle } from 'templates/Bundles/PM_Dynamic/LLC';

const mapConfigs: Record<
  EConfigs,
  Partial<Record<EBundlesInternalViewModel, any>>
> = {
  // BUNDLE
  [EConfigs.desktopMaxWidth]: {
    [EBundlesInternalViewModel.JACKPOT_SLOTS]: '400px',
    [EBundlesInternalViewModel.MAIN_SUB]: '400px',
    [EBundlesInternalViewModel.BIG_FISH_CASINO]: '400px',
    [EBundlesInternalViewModel.LIGHTNING_LINK_CASINO]: '400px',
    [EBundlesInternalViewModel.MIGHTY_FU_CASINO]: '400px',
    [EBundlesInternalViewModel.HEART_OF_VEGAS]: '400px',
    [EBundlesInternalViewModel.PIPA]: '528px',
    [EBundlesInternalViewModel.PLAY_SIMPLE]: '400px',
    [EBundlesInternalViewModel.BINGO_POP]: '400px',
  },
  [EConfigs.maxWidthOverride]: {
    [EBundlesInternalViewModel.MAIN_SUB]: '400px',
    [EBundlesInternalViewModel.WHISPERS]: '196px',
    [EBundlesInternalViewModel.BABA]: '400px',
  },
  [EConfigs.gapX]: {
    [EBundlesInternalViewModel.PLAY_SIMPLE]: '18px',
    [EBundlesInternalViewModel.WHISPERS]: '17px',
    [EBundlesInternalViewModel.PIPA]: '8px',
  },
  [EConfigs.gapY]: {
    [EBundlesInternalViewModel.BAGELCODE]: '8px',
    [EBundlesInternalViewModel.BAGELCODE2]: '8px',
    [EBundlesInternalViewModel.PIPA]: '8px',
  },
  [EConfigs.marginTop]: {
    [EBundlesInternalViewModel.PLAY_SIMPLE]: '0px',
    [EBundlesInternalViewModel.WHISPERS]: '25px',
  },
  // BANNER
  [EConfigs.bannerMaxWidth]: {
    [EBundlesInternalViewModel.WHISPERS]: '418px',
    [EBundlesInternalViewModel.PIPA]: '528px',
    [EBundlesInternalViewModel.PLAY_SIMPLE]: '322px',
  },
  [EConfigs.bannerMinWidth]: {
    [EBundlesInternalViewModel.WHISPERS]: '343px',
    [EBundlesInternalViewModel.PLAY_SIMPLE]: '224px',
  },
  [EConfigs.bannerMX]: {
    [EBundlesInternalViewModel.PLAY_SIMPLE]: '25%',
  },
  // ROLLING OFFER
  [EConfigs.rollingOfferMaxWidth]: {
    [EBundlesInternalViewModel.MAIN_SUB]: '400px',
    [EBundlesInternalViewModel.CANDIVORE]: '400px',
  },
};

const defaultConfigs: Record<EConfigs, any> = {
  // BUNDLE
  [EConfigs.desktopMaxWidth]: '1250px',
  [EConfigs.maxWidthOverride]: '400px',
  [EConfigs.gapX]: '12px',
  [EConfigs.gapY]: undefined,
  [EConfigs.marginTop]: '10px',
  // BANNER
  [EConfigs.bannerMaxWidth]: undefined,
  [EConfigs.bannerMinWidth]: undefined,
  [EConfigs.bannerMX]: undefined,
  // ROLLING OFFER
  [EConfigs.rollingOfferMaxWidth]: '1250px',
};

export const getTemplateProperty: any = (
  property: EConfigs,
  viewModel: EBundlesInternalViewModel,
) => mapConfigs[property][viewModel] || defaultConfigs[property];

export const mapBundleViewModel: Record<
  EBundlesInternalViewModel,
  React.FC<BundleProps>
> = {
  [EBundlesInternalViewModel.AK]: ClassicBundle,
  [EBundlesInternalViewModel.COMMUNIX]: CommunixBundle,
  [EBundlesInternalViewModel.COMMUNIX2]: Communix2Bundle,
  [EBundlesInternalViewModel.MATCH]: CandivoreBundle,
  [EBundlesInternalViewModel.CANDIVORE]: Candivore2Bundle,
  [EBundlesInternalViewModel.MAIN_SUB]: MainSubBundle,
  [EBundlesInternalViewModel.BAGELCODE]: BagelcodeBundle,
  [EBundlesInternalViewModel.BAGELCODE2]: Bagelcode2Bundle,
  [EBundlesInternalViewModel.LOCO_BINGO]: LocoBingoBundle,
  [EBundlesInternalViewModel.JACKPOT_SLOTS]: JackpotSlotsBundle,
  [EBundlesInternalViewModel.BIG_FISH_CASINO]: JackpotSlotsBundle,
  [EBundlesInternalViewModel.CASHMAN_CASINO]: CashmanCasinoBundle,
  [EBundlesInternalViewModel.LIGHTNING_LINK_CASINO]: LightningLinkBundle,
  [EBundlesInternalViewModel.EVERGREEN_DYNAMIC]: EvergreenDynamicBundle,
  [EBundlesInternalViewModel.HEART_OF_VEGAS]: HeartOfVegasBundle,
  [EBundlesInternalViewModel.ME2ON]: Me2onBundle,
  [EBundlesInternalViewModel.PLAY_SIMPLE]: PlaySimpleBundle,
  [EBundlesInternalViewModel.PIPA]: PipaBundle,
  [EBundlesInternalViewModel.WHISPERS]: WhispersBundle,
  [EBundlesInternalViewModel.BABA]: BabaBundle,
  [EBundlesInternalViewModel.MIGHTY_FU_CASINO]: MightyFuBundle,
  [EBundlesInternalViewModel.GHOST]: GhostBundle,
  [EBundlesInternalViewModel.BINGO_POP]: BingoPopBundle,
  [EBundlesInternalViewModel.LIGHTNING_LINK_CASINO2]:
    DynamicLightningLinkBundle,
  [EBundlesInternalViewModel.DYNAMIC_HEART_OF_VEGAS]: DynamicHeartOfVegasBundle,
};

export const mapSpecialOfferViewModel: Record<
  ESpecialOfferInternalViewModel,
  React.FC<SpecialOfferProps>
> = {
  [ESpecialOfferInternalViewModel.HUGE]: HugeSpecialOffer,
  [ESpecialOfferInternalViewModel.MATCH_MASTERS]: MatchMastersSpecialOffer,
  [ESpecialOfferInternalViewModel.POKER_FACE]: PokerFaceSpecialOffer,
  [ESpecialOfferInternalViewModel.BAGELCODE]: BagelCodeSpecialOffer,
  [ESpecialOfferInternalViewModel.LOCO_BINGO]: LocoBingoSpecialOffer,
  [ESpecialOfferInternalViewModel.ME2ON]: Me2onSpecialOffer,
  [ESpecialOfferInternalViewModel.PIPA]: PipaSpecialOffer,
  [ESpecialOfferInternalViewModel.JACKPOT_SLOTS]: ProductMadnessSpecialOffer,
  [ESpecialOfferInternalViewModel.BIG_FISH_CASINO]: ProductMadnessSpecialOffer,
  [ESpecialOfferInternalViewModel.BABA]: BabaSpecialOffer,
  [ESpecialOfferInternalViewModel.PLAY_SIMPLE]: PlaySimpleSpecialOffer,
  [ESpecialOfferInternalViewModel.GHOST]: GhostSpecialOffer,
  [ESpecialOfferInternalViewModel.BINGO_POP]: BingoPopSpecialOffer,
};

export const mapPlayerLevelViewModel: Partial<
  Record<EBundlesInternalViewModel | string, any>
> = {
  [EBundlesInternalViewModel.HEART_OF_VEGAS]: HeartOfVegasMapPlayerLevel,
  [EBundlesInternalViewModel.LIGHTNING_LINK_CASINO]: LightningLinkPlayerLevel,
  [EBundlesInternalViewModel.CASHMAN_CASINO]: CashmanCasinoPlayerLevel,
};
